import { Box, Dialog, Grid, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import UnlockHeading from '../../pages/mystery-box/images/unlock-heading.png';
import RevealButton from '../../pages/mystery-box/images/reaveal.png';
import { useNavigate, useLocation } from 'react-router-dom';
import Lottie from 'lottie-react';
import RegisterDrawer from './component/registerDrawer';
import UnlockDrawer from './component/unlockDrawer';
import ErrorAlert from './component/errorAlert';
import MysteryBox from './images/Myster box.json';
import Remember from './images/step screen 02.json';
import MysteryLogo from './images/Mystery logo.json';
import MysteryBoxHalfOpen from './images/mystery box half open.json';
import Faq from './component/faq';

const deals = [
  {
    name: "Reliance Digital",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/reliance-digital.png",
    link: 'cashkaro://stores/reliancedigital-coupons-excl-offr-mar26',
    cashback:'Upto 3% Cashback',
    bonus:'Flat ₹210 Bonus',
  },
  {
    name: "SSBeauty",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/ss-beauty.png",
    link: 'cashkaro://stores/ssbeauty-coupons-excl-offr-mar26',
    cashback:'Flat 18% Cashback',
    bonus:'Flat ₹140 Bonus',
  },
  {
    name: "Agoda",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/agoda.png",
    link: 'cashkaro://stores/agoda-excl-offr-mar26',
    cashback:'Flat 3.5% Cashback',
    bonus:'Flat ₹105 Bonus',
  },
  {
    name: "Croma",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/croma.png",
    link: 'cashkaro://stores/croma-excl-offr-mar26',
    cashback:'Upto 3% Cashback',
    bonus:'Flat ₹ 90 Bonus',
  },
  {
    name: "Muscleblaze",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/muscle-blaze.png",
    link: 'cashkaro://stores/muscleblaze-coupon-codes-excl-offr-mar26',
    cashback:'Flat 10% Cashback',
    bonus:'Flat ₹80 Bonus',
  },
  {
    name: "Shyaway",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/shyway.png",
    link: 'cashkaro://stores/shyaway-coupons-excl-offr-mar26',
    cashback:'Flat 25% Cashback',
    bonus:'Flat ₹75 Bonus',

  },
  {
    name: "Jivisa",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/jivisa.png",
    link: 'cashkaro://stores/jivisa-offers-excl-offr-mar26',
    cashback:'Flat 65% Cashback',
    bonus:'Flat ₹65 Bonus',

  },
  {
    name: "Koparo Clean",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/koparo.png",
    link: 'cashkaro://stores/koparoclean-coupons-excl-offr-mar26',
    cashback:'Flat 40% Cashback',
    bonus:'Flat ₹60 Bonus',

  },
  {
    name: "Hyugalife",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/hyugalife.png",
    link: 'cashkaro://stores/hyugalife-coupons-excl-offr-mar26',
    cashback:'Upto 10% Cashback',
    bonus:'Flat ₹55 Bonus',

  },
  {
    name: "Nykaa",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/nykaa.png",
    link: 'cashkaro://stores/nykaa-excl-offr-mar26',
    cashback:'Upto 6% Cashback',
    bonus:'Flat ₹50 Bonus',

  },
  {
    name: "Expedia",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/expedia.png",
    link: 'cashkaro://stores/expedia-flightbookings-excl-offr-mar26',
    cashback:'Upto 3% Cashback',
    bonus:'Flat ₹50 Bonus',

  },
  // {
  //   name: "Bewakoof.com",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/bewakoof.png",
  //   link: 'cashkaro://stores/bewakoof-excl-offr-mar26',
  //   cashback:'Flat 18% Cashback',
  //   bonus:'Flat ₹45 Bonus',

  // },
  {
    name: "OTT Play",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/ott.png",
    link: 'cashkaro://stores/ottplay-super-play-coupons-excl-offr-mar26',
    cashback:'Flat ₹149 Cashback',
    bonus:'Flat ₹40 Bonus',

  },
  {
    name: "Libas",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/libas.png",
    link: 'cashkaro://stores/libas-coupons-excl-offr-mar26',
    cashback:'Flat 7% Cashback',
    bonus:'Flat ₹40 Bonus',

  },
  {
    name: "Nutrabay",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/nutrabay.png",
    link: 'cashkaro://stores/nutrabay-coupon-codes-excl-offr-mar26',
    cashback:'Upto 10% Cashback',
    bonus:'Flat ₹35 Bonus',

  },
  {
    name: "Clove Oral Care",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/cclove.png",
    link: 'cashkaro://stores/clove-oral-care-coupons-excl-offr-mar26',
    cashback:'Upto 75% Cashback',
    bonus:'Flat ₹30 Bonus',

  },
  // {
  //   name: "Bajaj Prime",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/prime.png",
  //   link: 'cashkaro://stores/bajaj-prime-coupons-excl-offr-mar26',
  //   cashback:'Flat ₹625 Cashback',
  //   bonus:'Flat ₹30 Bonus',

  // },
  {
    name: "Zandu Care",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/zanduu.png",
    link: 'cashkaro://stores/zanducare-coupons-excl-offr-mar26',
    cashback:'Flat 18% Cashback',
    bonus:'Flat ₹30 Bonus',

  },
  {
    name: "The Derma Co",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/derma-co.png",
    link: 'cashkaro://stores/thedermaco-coupons-excl-offr-mar26',
    cashback:'Upto 20% Cashback',
    bonus:'Flat ₹25 Bonus',

  },
  {
    name: "Cleevo",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/cleevoo.png",
    link: 'cashkaro://stores/cleevo-offers-excl-offr-mar26',
    cashback:'Flat 30% Cashback',
    bonus:'Flat ₹25 Bonus',

  },
  {
    name: "MamaEarth",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/mamaearth.png",
    link: 'cashkaro://stores/mama-earth-coupons-excl-offr-mar26',
    cashback:'Upto 18% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "mCaffeine",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/m-caffine.png",
    link: 'cashkaro://stores/mcaffeine-coupons-excl-offr-mar26',
    cashback:'Flat 15% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Oppo",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/oppo.png",
    link: 'cashkaro://stores/oppo-coupons-excl-offr-mar26',
    cashback:'Upto 3% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Foxtale",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/foxtale.png",
    link: 'cashkaro://stores/foxtale-coupons-excl-offr-mar26',
    cashback:'Upto 15% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Dot and Key",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/dot-and-key.png",
    link: 'cashkaro://stores/dotandkey-coupons-excl-offr-mar26',
    cashback:'Upto 15% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Clovia",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/clovia.png",
    link: 'cashkaro://stores/clovia-coupons-excl-offr-mar26',
    cashback:'Flat 12% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Hyphen",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/hyphen.png",
    link: 'cashkaro://stores/hyphen-coupon-codes-excl-offr-mar26',
    cashback: 'Flat 12% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  // {
  //   name: "BoAt",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/boat.png",
  //   link: 'cashkaro://stores/boat-coupon-excl-offr-mar26',
  //   cashback:'Flat 5% Cashback',
  //   bonus:'Flat ₹20 Bonus',

  // },
  {
    name: "Decathlon",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/decathlon.png",
    link: 'cashkaro://stores/decathlon-coupon-excl-offr-mar26',
    cashback:'Flat 2.5% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "The Man Company",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/man-company.png",
    link: 'cashkaro://stores/themancompany-coupons-excl-offr-mar26',
    cashback:'Upto 15% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Ajio",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/ajioo.png",
    link: 'cashkaro://stores/ajio-coupons-excl-offr-mar26',
    cashback:'Upto 8% Cashback',
    bonus:'Upto ₹75 Bonus',

  },
  {
    name: "Truemeds",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/netmed.png",
    link: 'cashkaro://stores/truemeds-coupon-code-excl-offr-mar26',
    cashback:'Upto ₹370 Cashback',
    bonus:'Flat ₹15 Bonus',

  },
  {
    name: "Realme",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/realme.png",
    link: 'cashkaro://stores/realme-offers-excl-offr-mar26',
    cashback:'Upto 5.5% Cashback',
    bonus:'Flat ₹15 Bonus',

  },
  {
    name: "Healthkart",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/healthkart.png",
    link: 'cashkaro://stores/healthkart-excl-offr-mar26',
    cashback:'Flat 3% Cashback',
    bonus:'Flat ₹15 Bonus',

  },
  {
    name: "Flipkart",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/flipkartm.png",
    link: 'cashkaro://stores/flipkart-excl-offr-mar26',
    cashback:'Upto 7% Cashback',
    bonus:'Upto ₹75 Bonus',

  },
  {
    name: "Amazon",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/amazonm.png",
    link: 'cashkaro://stores/amazon-excl-offr-mar26',
    cashback:'Upto 3.5% Rewards',
    bonus:'Upto ₹75 Bonus',

  },
  {
    name: "Myntra",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/myntram.png",
    link: 'cashkaro://stores/myntra-excl-offr-mar26',
    cashback:'Upto 6% Cashback',
    bonus:'Upto ₹75 Bonus',

  },
  {
    name: "Firstcry",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/first-cry.png",
    link: 'cashkaro://stores/firstcry-excl-offr-mar26',
    cashback:'Upto ₹35 Cashback',
    bonus:'Flat ₹10 Bonus',

  },
  
];

const randomNames = [
  "Rahul",
  "Sneha",
  "Amit",
  "Priya",
  "Rohan",
  "Anjali",
  "Vikas",
  "Neha",
  "Karan",
  "Simran",
  "Arjun",
  "Pooja",
  "Diksha",
  "Abhishek",
  "Hirdesh",
  "Vridhi",
  "Suraj",
  "Aayush"
];


export default function MysteryBoxJan() {

  const [alertOpen, setAlertOpen] = useState(false);
  const [transaction, setTransaction] = useState(0);
  const [reveal, setReveal] = useState(false);
  const [registered, setRegistered] = useState(false);
  const [mbOpen, setMbOpen] = useState(localStorage.getItem('mb_open_march_new_cg') || 0);
  const navigate = useNavigate();
  const location = useLocation();
  const cta1Ref = useRef(null);
  const [error, setError] = useState(false)
  const [daysLeft, setDaysLeft] = useState([])
  const [openModal, setOpenModal] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);
  const [unlockDrawerOpen, setUnlockDrawerOpen] = useState(false);
  const [unlockBonusAmount, setUnlockBonusAmount] = useState(localStorage.getItem('mb_bonus_march_new_cg') || 0);
  const mysteryBoxSequenceRef = useRef({ timer1: null, timer2: null });
  const hasRedirectedToBonusRef = useRef(false);
  const productsRef = useRef(null);
    const [randomUser, setRandomUser] = useState('');
  const [randomAmount, setRandomAmount] = useState(0);

  const generateRandomUnlock = () => {
    setRandomUser(randomNames[Math.floor(Math.random() * randomNames.length)]);
    setRandomAmount(Math.floor(Math.random() * 450) + 50);
  };

  useEffect(() => {
    generateRandomUnlock();
    const interval = setInterval(generateRandomUnlock, 10000);
    return () => clearInterval(interval);
  }, []);




  function daysUntilMarch31() {
    const today = new Date();
    const currentYear = today.getFullYear();
    const march31 = new Date(currentYear, 2, 31);
    if (today > march31) march31.setFullYear(currentYear + 1);
    return Math.ceil((march31 - today) / (1000 * 60 * 60 * 24)) + 1;
  }

  useEffect(() => {
    const days = daysUntilMarch31().toString().split('');
    setDaysLeft(days.length < 2 ? ['0', ...days] : days);
  }, []);

  const handleImageClick = async () => {

    if (transaction > 0) {
      setReveal(true);
      localStorage.setItem('mb_open_march_new_cg', 1)
      try {
        const params = new URLSearchParams(window.location.search);
        let ck_id = params.get('userid') || params.get('user_id') || params.get('userId') || params.get('ck_id') || params.get('ckid')
        let response = await fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/updatedata_mb_mar`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            "ck_id": `${ck_id}`,
            "claim": 1
          })

        })
        response = await response.json();
        if (response?.message) {
          navigate('/mystery-box-march-new-cg/congrats', { replace: true });
        }
      } catch {
        // claim API failed
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    checkFunction()
  }, [])

  // Clear mystery-box sequence timers on unmount
  useEffect(() => {
    return () => {
      const refs = mysteryBoxSequenceRef.current;
      if (refs.timer1) clearTimeout(refs.timer1);
      if (refs.timer2) clearTimeout(refs.timer2);
    };
  }, []);

  // For registered users: fetch bonus for unlock content on index page
  useEffect(() => {
    if (!registered) return;
    const ck_id = localStorage.getItem('mb_ck_id_march_new_cg');
    if (!ck_id) return;
    fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/getuserdata_mb_mar?ck_id=${ck_id}`)
      .then((res) => res.json())
      .then((data) => {
        const bonusVal = data?.user_data?.bonus;
        if (bonusVal != null) {
          setUnlockBonusAmount(bonusVal);
          localStorage.setItem('mb_bonus_march_new_cg', bonusVal);
        }
      })
      .catch(() => {});
  }, [registered]);



  const checkFunction = async () => {
    const isMysteryBoxCgRoute = location.pathname.includes('mystery-box-march-new-cg');
    if (!isMysteryBoxCgRoute) return;
    if (hasRedirectedToBonusRef.current) return;

    const ckId = localStorage.getItem('mb_ck_id_march_new_cg');
    if (!ckId) {
      return;
    }
    try {
      setRegistered(true);
      const res = await fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/getuserdata_mb_mar?ck_id=${ckId}`);
      const data = await res.json();
      const userData = data?.user_data;
      setTransaction(userData?.transactions_tag ?? 0);
      if (userData?.bonus != null) localStorage.setItem('mb_bonus_march_new_cg', userData.bonus);
      if (userData?.bonus_added != null) localStorage.setItem('mb_bonus_added_march_new_cg', userData.bonus_added);
      if (userData?.claim != null) localStorage.setItem('mb_open_march_new_cg', userData.claim);
      // Avoid index↔bonus redirect loop:
      // - Bonus page redirects back to index when there is no transaction.
      // - So, do NOT redirect to bonus just because mbOpen===1 unless user is eligible.
      const hasTransaction = (userData?.transactions_tag ?? 0) > 0;
      console.log('checkFunction:', { userData, hasTransaction });
      const shouldGoToBonus =  hasTransaction;
      if (shouldGoToBonus) {
        hasRedirectedToBonusRef.current = true;
        navigate('/mystery-box-march-new-cg/bonus', { replace: true });
      }
    } catch {
      // On API failure, do not redirect (prevents index↔bonus loops)
    }
  };


  const handleButtonClick = () => navigate('/mystery-box-march-new-cg/congrats', { replace: true });

  const handleUnlockBonusClick = async () => {
    if (isRegistering) return;
    const params = new URLSearchParams(window.location.search);
    const ck_id = params.get('userid') || params.get('user_id') || params.get('userId') || params.get('ck_id') || params.get('ckid');
    if (!ck_id || ck_id === 'null') return;
    const refs = mysteryBoxSequenceRef.current;
    if (refs.timer1) clearTimeout(refs.timer1);
    if (refs.timer2) clearTimeout(refs.timer2);
    setIsRegistering(true);
    setOpenModal(true);
    try {
      // 1. Register API
      const registerRes = await fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/create_mb_mar_new_bonus?userId=${ck_id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      const registerData = await registerRes.json();
      if (registerData?.message === 'This is not lapsed user.') {
        setOpenModal(false);
        setIsRegistering(false);
        setError(true);
        return;
      }
      const savedCkId = registerData?.ck_id;
      if (savedCkId) {
        localStorage.setItem('mb_ck_id_march_new_cg', savedCkId);
      }
      // 2. Open mystery-box API
      const ckIdForOpen = savedCkId || localStorage.getItem('mb_ck_id_march_new_cg') || ck_id;
      fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/updatedata_mb_mar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ck_id: ckIdForOpen,
          open: 1,
        }),
      }).catch(() => {});
      // 3. Show open mystery-box design briefly, then unlock drawer, then return to index page
      refs.timer1 = setTimeout(() => {
        setOpenModal(false);
        setUnlockDrawerOpen(true);
      }, 200);
      refs.timer2 = setTimeout(() => {
        setUnlockDrawerOpen(false);
        setIsRegistering(false);
        setRegistered(true);
        navigate('/mystery-box-march-new-cg/index', { replace: true });
      }, 5000);
    } catch {
      setOpenModal(false);
      setIsRegistering(false);
      setError(true);
    }
  };

  return (
    <Grid container >
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
      {transaction < 1 ? (
        <Grid item xs={12} sm={12} md={4} lg={4}
          sx={{
            backgroundImage: "url(https://d2sriifpjiqv0p.cloudfront.net/mystery-box/first_bg.png)",
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#403326',
            position: 'relative',
            overflow: 'visible',
            minHeight: '100vh',
            // backgroundPosition: 'top',
          }}>
          <Box sx={{
            position: 'relative', width: '100%', overflow: 'hidden', zIndex: 2,
          }}>
            
            <Box id='cta'>
              {/* Hide treasure chest / unlock section when showing inline unlock content (registered, no transaction yet) */}
              {(!registered || transaction > 0) && (
                <>
                  <div style={{ display: 'flex', justifyContent: 'center', }}>
                    <Lottie
                      animationData={MysteryLogo}
                      loop
                      autoplay
                      style={{ width: "100%", }}
                    />
                  </div>
                  <div style={{ display: registered ? 'none' : 'flex', justifyContent: 'center', paddingTop: '24px' }}>
                    <img src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/offer-tg.png" alt="heading" style={{ width: window.innerWidth < 361 ? '70%' : '70%', }} />
                  </div>
                  <div style={{ display: registered ? 'flex' : 'none', justifyContent: 'center', paddingTop: '12px' }}>
                    <img src="{UnlockHeading}" alt="heading" style={{ width: '80%' }} />
                  </div>

                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Lottie
                      animationData={MysteryBox}
                      loop
                      autoplay
                      style={{ width: "100%", }}
                    />
                  </Box>

                  {daysLeft.length > 0 &&
                    <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection:'column', alignItems:'center' }} mt={3}>
                      <Typography sx={{ position: 'relative', zIndex: 1, color: '#fff', fontWeight: '500', lineHeight: '100%', fontSize: '13.93px', fontFamily: "Metropolis", }}>
                        <span style={{ padding: '2px 7px', borderRadius: '4px', fontFamily: 'Averia Serif Libre', color: '#F9C98C', fontWeight: '700', fontSize: '25px', lineHeight: '100%' }}>{daysLeft} DAYS LEFT</span>
                      </Typography>
                      <Typography sx={{ position: 'relative', zIndex: 1, color: '#fff', fontWeight: '500', lineHeight: '100%', fontSize: '13.93px', fontFamily: "Metropolis", }} mt={1}>
                      to Unlock your bonus
                      </Typography>
                    </Box>
                    
                  }
                </>
              )}

              <div ref={cta1Ref}>
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection:'column' }}>

                  {!registered ? (
                    <>
                    <Box sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: '1rem',
                    }}>
                      <img
                        src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/unlockBonus.png"
                        alt="Unlock bonus"
                        style={{ width: '80%', visibility: error ? 'hidden' : 'visible', opacity: isRegistering ? 0.7 : 1, cursor: isRegistering ? 'not-allowed' : 'pointer' }}
                        onClick={isRegistering ? undefined : handleUnlockBonusClick}
                      />
                    </Box>
                    <Box
                  sx={{
                    background: "linear-gradient(90deg, #403326 0%, #6C5743 50%, #403326 100%)",
                    border: "1px solid",
                    borderImageSource:
                      "linear-gradient(90deg, #403326 0%, #90705B 50%, #403326 100%)",
                    borderImageSlice: 1,
                  }} mb={3}
                >
<Typography
  sx={{
    textAlign: "center",
    color: "#EDD0B9",
    fontWeight: 700,
    fontSize: "12px",
    fontFamily: "metropolis",
  }}
>
  <span style={{ fontWeight: 800 }}>{randomUser}</span> just unlocked{" "}
  <span style={{ color: "#F9C98C", fontWeight: 900 }}>
    ₹{randomAmount}
  </span>{" "}
  Bonus Cashback
</Typography>                </Box>
                  </>
                    
                  ) : transaction > 0 ? (
                    <img
                      src={RevealButton}
                      alt="Reveal"
                      style={{ width: '100%', paddingLeft: '1rem', paddingRight: '1rem' }}
                      onClick={handleButtonClick}
                    />
                  ) : (
                    <Box>
                      <div style={{ display: 'flex', justifyContent: 'center', }}>
                    <Lottie
                      animationData={MysteryLogo}
                      loop
                      autoplay
                      style={{ width: "100%", }}
                    />
                  </div>
                    <Box sx={{ width: '100%', textAlign: 'center' }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '12px' }}>
                        <Typography sx={{ fontFamily: 'Metropolis', fontSize: '16.79px', lineHeight: '100%', fontWeight: 600, color: '#fff', mb: 1 }}>
                          You have unlocked
                        </Typography>
                        <Typography
  sx={{
    fontFamily: 'Metropolis',
    fontSize: { xs: '44px', sm: '60px' },
    fontWeight: 900,
    lineHeight: 0.95,
    textTransform: 'uppercase',
    letterSpacing: '1px',

    color: '#E8D7C3', // was shadow → now text

    textShadow: `
      3px 7px 0px #694426,
      2px 2px 4px rgba(0,0,0,0.25)
    `,
  }}
>
  ₹{unlockBonusAmount} BONUS <br /> CASHBACK
</Typography>
<Typography sx={{ fontFamily: 'Metropolis', fontSize: '16.79px', lineHeight: '100%', fontWeight: 600, color: '#fff', mb: 1 }} mt={1}>
Now shop at least once to claim it
                        </Typography>

                      </Box>
                      <Lottie animationData={MysteryBoxHalfOpen} loop autoplay style={{ width: '100%' }} />
                      {daysLeft.length > 0 &&
                    <Box sx={{ display: 'flex', justifyContent: 'center' }} mt={3}>
                      <Typography sx={{ position: 'relative', zIndex: 1, color: '#fff', fontWeight: '500', lineHeight: '100%', fontSize: '13.93px', fontFamily: "Metropolis", }}>
                        <span style={{ padding: '2px 7px', borderRadius: '4px', fontFamily: 'Averia Serif Libre', color: '#F9C98C', fontWeight: '700', fontSize: '25px', lineHeight: '100%' }}>{daysLeft} DAYS LEFT </span>
                      </Typography>
                    </Box>
                  }
                  <Typography sx={{ fontFamily: 'DM Sans', textAlign: 'center', fontWeight: 500, fontSize: '14px', lineHeight: '100%', color: '#fff', px: 2, mt: 1 }}>
                  To claim your Bonus Cashback
                      </Typography>
                      <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                        <img
                          src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/unlockButton.png"
                          alt="View Bonus"
                          style={{ width: '80%', display: 'block', cursor: 'pointer' }}
                          onClick={() => document.getElementById('bonus-cb')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                        />
                      </Box>
                    </Box>
                    </Box>
                  )}
                </div>
              </div>



            </Box>
          </Box>

          {!registered || transaction > 0 ? null : (
            <Box>
              <Box
                ref={productsRef}
                id='products' sx={{
                  marginTop: '-10px', background: "radial-gradient(50% 50% at 50% 50%, #191109 0%, #403326 100%)"
                }}>
                <Box
                  sx={{
                    background: "linear-gradient(90deg, #403326 0%, #6C5743 50%, #403326 100%)",
                    border: "1px solid",
                    borderImageSource:
                      "linear-gradient(90deg, #403326 0%, #90705B 50%, #403326 100%)",
                    borderImageSlice: 1,
                  }} 
                >
<Typography
  sx={{
    textAlign: "center",
    color: "#EDD0B9",
    fontWeight: 700,
    fontSize: "12px",
    fontFamily: "metropolis",
  }}
>
  <span style={{ fontWeight: 800 }}>{randomUser}</span> just unlocked{" "}
  <span style={{ color: "#F9C98C", fontWeight: 900 }}>
    ₹{randomAmount}
  </span>{" "}
  Bonus Cashback
</Typography>                </Box>


                <Box
                  sx={{
                    background: "linear-gradient(111.27deg, #F6CFB0 25.31%, #FFFFFF 74.69%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    fontFamily: "Averia Serif Libre",
                    fontWeight: 700,
                    fontSize: "35px",
                    textAlign: "center",
                  }} mt={3} 
                  id="trending-deals"
                >
                  Trending Deals
                </Box>
                <Box
                  sx={{
                    color: '#fff',
                    fontFamily: "metropolis",
                    fontWeight: 500,
                    fontSize: "14px",
                    textAlign: "center",
                  }}
                >
                  Explore top deals of the day
                </Box>

                <Grid container px={2} mt={3}>
                  <Grid item xs={6} sm={6}>
                    <a href='cashkaro://top-selling-products/flash-deals'>
                    <Box
                      component="img"
                      src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/flashDeal.png"
                      alt="banner"
                      sx={{ width: '100%', }}
                    />
                    </a>
                  </Grid>

                  <Grid item xs={6} sm={6}>
                    <Box
                      component="img"
                      src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/bonusimg.png"
                      alt="banner"
                      sx={{ width: '100%', }}
                      onClick={() => {
                        const el = document.getElementById("bonus-cb");
                        if (el) {
                          const yOffset = -20; // adjust if needed
                          const y =
                            el.getBoundingClientRect().top +
                            window.pageYOffset +
                            yOffset;
                  
                          window.scrollTo({
                            top: y,
                            behavior: "smooth",
                          });
                        }
                      }}
                    />
                  </Grid>
                </Grid>
                <a href='cashkaro://home'>
                <Box
                  component="img"
                  src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/HOMEPAGE.png"
                  alt="banner"
                  sx={{ width: '100%', }} px={3} pt={1}
                />
                </a>
                <Grid container px={2}>
                  <Grid item xs={6} sm={6}>
                  <a href="cashkaro://products/home-categories-exclusive/fashion-offers">
                    <Box
                      component="img"
                      src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/fashionCat.png"
                      alt="banner"
                      sx={{ width: '100%', }}
                    />
                    </a>
                  </Grid>

                  <Grid item xs={6} sm={6}>
                  <a href="cashkaro://products/home-categories-exclusive/beauty-personal-care-offers">
                    <Box
                      component="img"
                      src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/fourth.png"
                      alt="banner"
                      sx={{ width: '100%', }}
                    />
                    </a>
                  </Grid>
                </Grid>

                <Box id='bonus-cb'
                  sx={{
                    background: "linear-gradient(111.27deg, #F6CFB0 25.31%, #FFFFFF 74.69%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    lineHeight: '100%',
                    fontFamily: "Averia Serif Libre",
                    fontWeight: 700,
                    fontSize: "35px",
                    textAlign: "center",
                  }} mt={3}
                >
                  Earn Bonus <br />Cashback
                </Box>
                <Box>
                  <Grid container spacing={2} justifyContent="center" px={2} pt={5} mb={4}>
                    {deals.map((item, index) => (
                      <Grid item xs={4} sm={4} md={4} key={index}>
                        <Box
                          sx={{
                            textAlign: "center",
                            color: "#E6D8C9",
                          }}
                        >
                          <Box
                            component="img"
                            src={item.img}
                            alt={item.name}
                            sx={{
                              width: "100%",
                              objectFit: "contain",
                              mx: "auto",
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: { xs: "10px" },
                              fontWeight: 600,
                              background: "linear-gradient(90deg, #B9A593 0%, #93785F 100%)",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                              fontFamily: 'metropolis'
                            }}
                          >
                            {item.name}
                          </Typography>
                          <Typography
                            sx={{
                              mt: 1,
                              fontSize: "11px",
                              fontWeight: 600,
                              background: "linear-gradient(90deg, #F8DBC4 0%, #FFFFFF 100%)",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                              fontFamily: 'metropolis'

                            }}
                          >
                            {item.cashback}
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: "11px",
                              fontWeight: 600,
                              background: "linear-gradient(90deg, #F8DBC4 0%, #FFFFFF 100%)",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                              fontFamily: 'metropolis'
                            }}
                          >
                            + {item.bonus}
                          </Typography>
                          <a
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: "inline-block",
                              textDecoration: "none",
                            }}
                          >
                            <img
                              src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/shopNow.png"
                              alt="Shop Now"
                              style={{
                                width: "100%",
                                maxWidth: "180px",
                                display: "block",
                                marginTop: "10px",
                                cursor: "pointer",

                              }}
                            />
                          </a>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>



              </Box>
            </Box>
          )}

<Box >
<Faq/>
</Box>
          
          <RegisterDrawer
            open={alertOpen}
            setOpen={setAlertOpen}
            setError={setError}
            setRegistered={setRegistered}
            checkFunction={checkFunction}
            onRegisterSuccess={() => {
              setAlertOpen(false);
              setOpenModal(true);
            }}
            onRedirect={() => {}}
          />
          <UnlockDrawer open={unlockDrawerOpen} setOpen={setUnlockDrawerOpen} />
          {/* <Dialog
            open={openModal}
            onClose={() => setOpenModal(false)}
            fullScreen
            PaperProps={{
              sx: {
                margin: 0,
                borderRadius: 0,
                background: '#7e6852',
                alignItems: 'center',
                justifyContent: 'center',
              },
            }}
          >
            <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Lottie animationData={Remember} loop autoplay style={{ width: '100%', height: '100%' }} />
            </Box>
          </Dialog> */}
          <ErrorAlert open={error} type="error" message="You are not eligible for this campaign!" setOpen={setError} />

        </Grid>
      ) : (




        <Grid item xs={12} sm={12} md={4} lg={4}
          sx={{
            backgroundImage: "url(https://d2sriifpjiqv0p.cloudfront.net/mystery-box/first_bg.png)", backgroundSize: 'contain'
          }}>
          <Box sx={{
            position: 'relative', width: '100%', overflow: 'hidden',
          }}>
           
            <Box
            >
              <div style={{ display: 'flex', justifyContent: 'center', }}>
                <Lottie
                  animationData={MysteryLogo}
                  loop
                  autoplay
                  style={{ width: "100%", }}
                />
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '12px', alignItems:'center' }}>
                {/* <img src={Mbheading} alt="heading" style={{ width: '100%' }} /> */}
                {/* <Typography sx={{ fontSize: '16.79px', fontWeight: '600', color: '#fff', lineHeight: '100%', fontFamily: 'metropolis', textAlign: 'center' }}>CLAIM UPTO</Typography> */}
                <img src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/offer.png" alt="Offer" style={{ width: '80%' }} />
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '12px' }}>
                <Lottie
                  animationData={MysteryBox}
                  loop
                  autoplay
                  style={{ width: "100%", }}
                />
              </div>
              {daysLeft.length > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', paddingTop: '12px' }}>
                <Typography sx={{ position: 'relative', zIndex: 1, color: '#F9C98C', fontWeight: '700', fontSize: '24px', fontFamily: 'Averia Serif Libre', textAlign: 'center' }}>
                  {daysLeft[1]} DAYS LEFT
                </Typography>
              </Box>
              )}
              <div ref={cta1Ref} style={{
                display: 'flex',
                justifyContent: 'center',
                bottom: '0',
                width: '100%',
                zIndex: '9999999',
              }}>
                {reveal ? (
                  <div style={{ display: 'flex', justifyContent: 'center', width: '100%', zIndex: '9999999' }}>
                    <img
                      src={RevealButton}
                      alt="RevealButton"
                      style={{ width: '100%', paddingLeft: '1rem', paddingRight: '1rem' }}
                      onClick={handleButtonClick}
                    />
                  </div>
                ) : (
                  <img
                    src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/openBox.png"
                    alt="Openimage"
                    style={{ width: '80%' }}
                    onClick={handleImageClick}
                  />
                )}
              </div>
            </Box>

          </Box>
          <Box>
<Faq/>
</Box>
        </Grid>
      )}
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>

    </Grid>
  );
}
